import React, { ReactNode } from 'react'

const SolicitudViolenciaSectionContainer = ({children}: {children: ReactNode }) => {
  return (
    <section className='form__background w-full p-6 mt-8'>
      {children}
    </section>
  )
}

export  {SolicitudViolenciaSectionContainer}